import __request__ from "routing/request";
export function checkCredentials(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.enterprise.integrations/awssecuritylake/checkCredentials", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAWSRegions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.enterprise.integrations/awssecuritylake/getawsregions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, setup_wizard = false, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.enterprise.integrations/awssecuritylake/inputs", JSONbody, { "setup_wizard": setup_wizard }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
